import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_DEVICES_CONNECTORS } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const addChargingDeviceConnectorsAPI: any = createAsyncThunk(
  "addChargingDeviceConnectors",
  async ({ formData, method, id }: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios({
        method: method,
        url: !!id
          ? CHARGING_DEVICES_CONNECTORS + id
          : CHARGING_DEVICES_CONNECTORS,
        data: formData,
        headers: commonHead,
      });
      return res;
    } catch (error: any) {
      // if (error instanceof Error) {
      return rejectWithValue({
        error: { code: error.response.code, message: error.message },
      });
      // }
    }
  }
);
